<template>
  <div class="change-status__header">
    <h4 class="change-status__fundname">{{ displayName }}</h4>
  </div>
</template>
<script>
export default {
  name: 'change-status-header',
  props: {
    displayName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss">
.change-status {
  &__header {
    background-color: #032736;
    padding: $mds-space-2-x;
  }
  &__fundname {
    @include mds-level-4-heading();
    color: $mds-color-neutral-67;
    font-weight: $mds-font-weight-thin;
    margin: 0;
  }
}
</style>
